module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/static-modal-app/img/button-android@3x__b5bf636dd95f071cb224c3b49b6751d8.png";